document.addEventListener('DOMContentLoaded', function () {
  document.body.prepend(
    document.body.querySelector('template#price-changes-announcement-bar-tmpl')
      ?.content
      ?.firstElementChild.cloneNode(true)
  )
});
class PriceChangesAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.template = document.querySelector('template#price-changes-announcement-bar-tmpl');
    this.futureNumDays = +this.template?.dataset?.futureNumDays;
    this.announcementTextTemplate = this.template?.dataset?.announcementTextTemplate;
    if (this.announcementTextTemplate) {
      this.announcementTextTemplate = this.announcementTextTemplate.replace('{{date_at}}', "<strong>{{date_at}}</strong>")
        .replace('{{time_at}}', "<strong>{{time_at}}</strong>");
    }
    this._updateAnnouncementText();
    setInterval(() => {
      this._updateAnnouncementText();
    }, 1000*60);
  }
  _updateAnnouncementText() {
    this.querySelector('.price-changes-announcement-bar-text').innerHTML =
      this._composeAnnouncement(
        this.announcementTextTemplate,
        this._calculateTimeRemaining(this.futureNumDays)
      );
  }
  _composeAnnouncement(announcementText, { futureDateFormatted, hoursRemaining, minutesRemaining }) {
    const formatTime = (value, singular, plural) => value === 1 ? `${value} ${singular}` : `${value} ${plural}`;
    let timeAt = formatTime(minutesRemaining, "minute", "minutes");
    if (hoursRemaining > 0) {
      timeAt = `${formatTime(hoursRemaining, "hour", "hours")} and ${timeAt}`;
    }
    return announcementText
      .replace('{{date_at}}', futureDateFormatted)
      .replace('{{time_at}}', timeAt);
  }
  _calculateTimeRemaining(futureNumDays) {
    const currentDate = new Date();
    const futureDate = new Date();
    futureDate.setDate(currentDate.getDate() + futureNumDays);

    const options = {month: 'long', day: 'numeric'};
    const futureDateFormatted = futureDate.toLocaleDateString(undefined, options);
    futureDate.setHours(23, 59, 0, 0);

    const timeDiff = futureDate.getTime() - currentDate.getTime();
    let hoursRemaining = 0;
    let minutesRemaining = 0;
    if (timeDiff > 0) {
      hoursRemaining = Math.floor(timeDiff / (1000 * 60 * 60));
      minutesRemaining = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    }
    return {
      futureDateFormatted,
      hoursRemaining,
      minutesRemaining
    }
  }
}
customElements.define('price-changes-announcement-bar', PriceChangesAnnouncementBar);
